import {Mapper} from '@s-ui/domain'

export class FromPageNameToLandingsBreadcrumbVOMapper extends Mapper {
  constructor({breadcrumbValueObjectFactory, config}) {
    super()

    this._config = config
    this._breadcrumbValueObjectFactory = breadcrumbValueObjectFactory
    this._appName = this._config.get('APP_NAME')
  }

  /**
   *  Get breadcrumbs for specific pages
   */

  _getDefaultBreadcrumbs = () => {
    const homeSegment = this._getHomeSegment()
    return [homeSegment]
  }

  _getLandingFinancingBreadcrumbs = () => {
    const {LANDING_FINANCING_PATH_PATTERN: url} = this._config.get('page')

    const homeSegment = {
      label: 'BREADCRUMB_LANDING_FINANCING_HOME_LABEL',
      url
    }
    const sectionSegment = {label: 'COMMON.FINANCING'}

    return [homeSegment, sectionSegment]
  }

  _getLandingFormalitiesBreadcrumbs = () => {
    const {SECOND_HAND_PATH_PATTERN: url} = this._config.get('page')

    const homeSegment = {
      label: `BREADCRUMB_LANDING_FORMALITIES_HOME_${this._appName}_LABEL`,
      url
    }
    const sectionSegment = {label: 'COMMON.FORMALITIES'}

    return [homeSegment, sectionSegment]
  }

  _getLandingFormalitiesSecurityGuidelinesBreadcrumbs = () => {
    const {SECOND_HAND_PATH_PATTERN: url} = this._config.get('page')

    const homeSegment = {
      label: `BREADCRUMB_LANDING_FORMALITIES_HOME_${this._appName}_LABEL`,
      url
    }
    const sectionSegment = {
      label: 'BREADCRUMB_LANDING_FORMALITIES_SECTION_LABEL'
    }

    return [homeSegment, sectionSegment]
  }

  _getVehicleAppraiserBreadcrumbs = () => {
    const {VEHICLE_APPRAISER_PATH_PATTERN: url} = this._config.get('page')

    const homeSegment = {
      label: 'LANDING_VEHICLE_APPRAISER.BREADCRUMBS.HOME',
      url
    }
    const sectionSegment = {
      label: 'LANDING_VEHICLE_APPRAISER.BREADCRUMBS.SECTION'
    }

    return [homeSegment, sectionSegment]
  }

  map = ({pageName}) => {
    const {
      LANDING_FINANCING_PAGE_NAME,
      LANDING_FORMALITIES_PAGE_NAME,
      LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME,
      VEHICLE_APPRAISER_PAGE_NAME
    } = this._config.get('page')

    const breadcrumbs = {
      [LANDING_FINANCING_PAGE_NAME]: this._getLandingFinancingBreadcrumbs(),
      [LANDING_FORMALITIES_PAGE_NAME]: this._getLandingFormalitiesBreadcrumbs(),
      [LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME]: this._getLandingFormalitiesSecurityGuidelinesBreadcrumbs(),
      [VEHICLE_APPRAISER_PAGE_NAME]: this._getVehicleAppraiserBreadcrumbs()
    }

    return this._breadcrumbValueObjectFactory({
      breadcrumbs: breadcrumbs[pageName]
    })
  }
}
